<template>
  <div>
    <b-container>
      <b-row class="justify-content-center">
        <b-col md="10">
          <h1>North Park University</h1>
          <h2>WordPress Website</h2>
          <p>North Park University is a private Christian university in Chicago, Illinois that enrolls more than 3,000 undergraduate and graduate students. My team and I developed an easily editable, custom WordPress theme for North Park University.</p>
          
          <b-button variant="primary" href="http://www.northpark.edu" target="_blank">
            Visit Website <font-awesome-icon icon="external-link-alt" class="ml-2" />
          </b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="6">
          <b-img fluid class="mt-3 mt-lg-5 w-100 border shadow" alt=""
            :src="require('../../assets/screens/npu-home.png')"
            :srcset="require('../../assets/screens/npu-home@2x.png') + ' 2x'" />
        </b-col>

        <b-col lg="6">
          <b-img fluid class="mt-3 mt-lg-5 w-100 border shadow" alt=""
            :src="require('../../assets/screens/npu-apply.png')"
            :srcset="require('../../assets/screens/npu-apply@2x.png') + ' 2x'" />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  export default {
    metaInfo: {
      titleTemplate: 'North Park University | %s',
    }
  }
</script>
